module.exports = __webpack_public_path__ + "img/icon4.14f8d8b0.png";